import { useEffect, useState, type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";

function QueryScope({ children }: { children: ReactNode }) {
  const [scope] = useState(() => ({
    client: new QueryClient(),
    mounted: false,
  }));
  useEffect(() => {
    scope.mounted = true;
    return () => {
      scope.mounted = false;
      queueMicrotask(() => {
        // StrictMode reactivates the same scope before this microtask. A replaced
        // scope stays inactive and must release its old workspace data and reads.
        if (!scope.mounted) scope.client.clear();
      });
    };
  }, [scope]);
  return (
    <QueryClientProvider client={scope.client}>{children}</QueryClientProvider>
  );
}

/** A changed scope creates a new cache and remounts forms before children render. */
export function QueryScopeProvider({
  scopeKey,
  children,
}: {
  scopeKey: string;
  children: ReactNode;
}) {
  return <QueryScope key={scopeKey}>{children}</QueryScope>;
}
export function SessionQueryProvider({ children }: { children: ReactNode }) {
  const { session } = useAuth();
  return (
    <QueryScopeProvider scopeKey={session.key}>{children}</QueryScopeProvider>
  );
}
